import { useLocation } from 'react-router-dom'
import { shallow } from 'zustand/shallow'

import Container from 'src/ui/molecules/Container'
import NetworkAndChainSelector from 'src/ui/molecules/NetworkAndChainSelector'
import HiddenInfo from 'src/ui/molecules/HiddenInfo'
import { useChainAndNetwork } from 'src/store/chainAndNetwork'

import EvmForm from './EvmForm'

const IssueContract = () => {
  const location = useLocation()
  const { chain } = useChainAndNetwork(
    (state) => ({
      chain: state.chain,
    }),
    shallow,
  )
  const isVesting = location.pathname === '/issue-vesting-contract'
  const isStaking = location.pathname === '/issue-staking-contract'

  return (
    <Container>
      <div className="grid gap-12">
        {isVesting && (
          <HiddenInfo
            title="What is a Vesting Smart Contract?"
            info="A Vesting Smart Contract is a type of blockchain contract that allows token holders to send
          tokens to others after a specific criteria has been met. For example, by using our Vesting
          Smart Contract you can vest loyal members of your community with your token and the smart
          contract will send it to their addresses after the unlock period has expired or at the date
          set by you via timestamp."
          />
        )}
        {isStaking && (
          <HiddenInfo
            title="What is a Staking Smart Contract?"
            info="A Staking Smart Contract is a type of blockchain contract that allows token holders to lock
          their tokens for a specific period of time and receive rewards in exchange. The APY is the
          percentage offered as reward and the rewards are offered in the same token that was staked.
          For example, if your Staking Smart Contract offers 10% APY, a user who staked 1000 ZPAY will
          receive after one year his initial 1000 ZPAY and 100 ZPAY as reward."
          />
        )}

        <NetworkAndChainSelector chains={['bnb', 'ethereum', 'polygon']} />

        <EvmForm chain={chain} />
      </div>
    </Container>
  )
}

export default IssueContract
